import { useQuery } from "@tanstack/react-query";
import classNames from "classnames";
import i18next from "i18next";
import { get } from "lodash";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { GamePlayerApi } from "states/api/gamePlayer";
import { formatNumber } from "_common/utils/formatValue";
import NoData from "_common/component/NoData";
import Pagination from "_common/component/Pagination";

export default function HistoryData() {
  const [active, setActive] = useState("pending");

  const { data, refetch } = useQuery(
    ["game-player", "list"],
    () =>
      GamePlayerApi.getList({
        params: {
          page: 1,
          limit: 10,
        },
      }),
    {
      staleTime: 300000,
    }
  );

  useEffect(() => {
    refetch();
  }, [active]);

  if (!data?.data?.length) return <NoData />;

  return (
    <>
      <div className="flex flex-col gap-4 bg-[#000000]">
        {get(data, "data", [])?.map((item) => (
          <div
            key={`item-${item?.toString()}`}
            className="p-4 bg-[#1c1c1e] rounded"
            style={{
              boxShadow:
                "rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px;",
            }}
          >
            <div className="flex justify-between border-b border-[#FFFFFF1A] pb-2 mb-4">
              <div className="flex flex-col gap-1 text-[#9ca3af]">
                <span className="text-[#9ca3af]">{item?.game?.name}</span>
                <span className="text-[13px] text-[#888]" />
              </div>
              <div className="flex flex-col items-end gap-1">
                {item?.bet_game === "buy" && (
                  <div className="py-1 px-3 text-[13px] text-white rounded bg-[#55af72]">
                    {i18next.t("transaction_purchaser")}{" "}
                    {formatNumber(Number(get(item, "type", 0) / 60))}{" "}
                    {i18next.t("minute")}
                  </div>
                )}
                {item?.bet_game === "sell" && (
                  <div className="py-1 px-3 text-[13px] text-white rounded bg-[#dd5350]">
                    {i18next.t("purchase_price")}{" "}
                    {formatNumber(Number(get(item, "type", 0) / 60))}{" "}
                    {i18next.t("minute")}
                  </div>
                )}
                <span className="text-[13px] text-[#888]">
                  {moment(item?.created_at).format("YYYY-MM-DD HH:mm")}
                </span>
              </div>
            </div>
            <div className="flex flex-col gap-2 mt-4">
              <div className="flex justify-between text-[15px] text-white">
                <span className="text-[14px] text-[#A3A3A3]">
                  {i18next.t("price_transaction")}
                </span>
                <span className="text-[13px] text-[#A3A3A3] ">
                  {formatNumber(item?.open, "0,0.[000000]")} USDT
                </span>
              </div>
              <div className="flex justify-between text-[15px] text-white">
                <span className="text-[14px] text-[#888]">
                  {i18next.t("money_amount")}
                </span>
                <span className="text-[13px] text-white">
                  {formatNumber(item?.amount, "0,0.[000000]")} USDT
                </span>
              </div>
              <div className="flex justify-between text-[15px] text-white">
                <span className="text-[14px] text-[#A3A3A3]">
                  {i18next.t("profit")}
                </span>
                {item?.amount_payback > 0 && (
                  <span className="text-[13px] text-[#f7a600]">
                    +{formatNumber(item?.amount_payback, "0,0.[000000]")} USDT
                  </span>
                )}
                {item?.amount_lose > 0 && (
                  <span className="text-[13px] text-[#dd5350]">
                    -{formatNumber(item?.amount_lose, "0,0.[000000]")} USDT
                  </span>
                )}
              </div>
              <div className="flex justify-between text-[15px] text-white">
                <span className="text-[14px] text-[#A3A3A3]">
                  {i18next.t("status")}
                </span>
                <span
                  className={classNames("text-[15px]", {
                    "text-[#55af72]": item?.amount_payback > 0,
                    "text-[#f70000]": item?.amount_lose > 0,
                  })}
                >
                  {i18next.t(item?.status)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <Pagination />
    </>
  );
}
